import { render, staticRenderFns } from "./textureCodeEditor.vue?vue&type=template&id=3e35ebaa"
import script from "./textureCodeEditor.vue?vue&type=script&lang=js"
export * from "./textureCodeEditor.vue?vue&type=script&lang=js"
import style0 from "./textureCodeEditor.vue?vue&type=style&index=0&id=3e35ebaa&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports